{
  "version": "1.10.33",
  "name": "aphasie-react-native",
  "private": true,
  "author": "Limedix GmbH",
  "license": "UNLICENSED",
  "main": "./src/index.js",
  "homepage": "https://patient-react-native.cellar-c2.services.clever-cloud.com",
  "scripts": {
    "fix": "eslint ./ --fix",
    "ts": "yarn tsc --noEmit",
    "gen-dependencies": "jq '.dependencies | keys' package.json > src/assets/dependencies.json",
    "therapist-dev-client": "eslint ./ --fix && APP_ENV=therapist expo start --dev-client",
    "patient-dev-client": "eslint ./ --fix && APP_ENV=patient expo start --dev-client",
    "therapist": "yarn gen-dependencies && eslint ./ --fix && APP_ENV=therapist npx expo start -c",
    "patient": "yarn gen-dependencies && eslint ./ --fix && APP_ENV=patient expo start -c",
    "start": "expo start --dev-client",
    "###########################": "",
    "deploy-therapist-production-web": "s3cmd sync -r --acl-public --no-mime-magic --guess-mime-type --delete-removed --no-preserve dist/aphasia-therapist-webapp/ s3://neolexon-aphasie-therapeutin-reactnative -c ~/.s3cfg-therapeut-staging && sentry-cli sourcemaps upload dist/aphasia-therapist-webapp/_expo/static/js/web",
    "predeploy-therapist-production-web": "EXPO_PUBLIC_API_URL=https://app.neolexon.de APP_ENV=therapist GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-therapist-webapp --dump-sourcemap",
    "deploy-patient-production-web": "s3cmd sync -r --acl-public --no-mime-magic --guess-mime-type --delete-removed --no-preserve dist/aphasia-patient-webapp/ s3://neolexon-aphasie-reactnative -c ~/.s3cfg-therapeut-staging && sentry-cli sourcemaps upload dist/aphasia-patient-webapp/_expo/static/js/web",
    "predeploy-patient-production-web": "EXPO_PUBLIC_CHARGEBEE_SITE=neolexon EXPO_PUBLIC_API_URL=https://app.neolexon.de APP_ENV=patient GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-patient-webapp --dump-sourcemap",
    "########################": "",
    "deploy-patient-staging-web": "s3cmd sync -r --acl-public --no-mime-magic --guess-mime-type --delete-removed --no-preserve dist/aphasia-patient-webapp/ s3://aphasie-development -c ~/.s3cfg-therapeut-staging && sentry-cli sourcemaps upload dist/aphasia-patient-webapp/_expo/static/js/web",
    "predeploy-patient-staging-web": "EXPO_PUBLIC_CHARGEBEE_SITE=neolexon-test EXPO_PUBLIC_API_URL=https://staging.neolexon.de APP_ENV=patient GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-patient-webapp --dump-sourcemap",
    "deploy-therapist-staging-web": "s3cmd sync -r --acl-public --no-mime-magic --guess-mime-type --delete-removed --no-preserve dist/aphasia-therapist-webapp/ s3://therapeut-development -c ~/.s3cfg-therapeut-staging && sentry-cli sourcemaps upload dist/aphasia-therapist-webapp/_expo/static/js/web",
    "predeploy-therapist-staging-web": "EXPO_PUBLIC_API_URL=https://staging.neolexon.de APP_ENV=therapist GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-therapist-webapp --dump-sourcemap",
    "#######################": "",
    "######################## BUILD SCRIPTS": "",
    "build-patient-app-web-production": "yarn gen-dependencies && EXPO_PUBLIC_LEGACY_BACKEND_COMPATIBILITY=true EXPO_PUBLIC_ENVIRONMENT=production EXPO_PUBLIC_CHARGEBEE_SITE=neolexon EXPO_PUBLIC_API_URL=https://app.neolexon.de EXPO_PUBLIC_POSTHOG_ENABLED=true EXPO_PUBLIC_POSTHOG_HOST=https://posthog.neolexon.de/ APP_ENV=patient expo export -c -p web --output-dir ./dist/aphasia-patient-webapp --dump-sourcemap",
    "build-therapist-app-web-production": "yarn gen-dependencies && EXPO_PUBLIC_LEGACY_BACKEND_COMPATIBILITY=true EXPO_PUBLIC_ENVIRONMENT=production EXPO_PUBLIC_API_URL=https://app.neolexon.de EXPO_PUBLIC_POSTHOG_ENABLED=false EXPO_PUBLIC_POSTHOG_HOST=https://posthog.neolexon.de/ APP_ENV=therapist expo export -c -p web --output-dir ./dist/aphasia-therapist-webapp --dump-sourcemap",
    "build-patient-app-web-staging": "yarn gen-dependencies && EXPO_PUBLIC_API_URL=https://app-staging.neolexon.de EXPO_PUBLIC_ENVIRONMENT=staging EXPO_PUBLIC_CHARGEBEE_SITE=neolexon-test EXPO_PUBLIC_POSTHOG_ENABLED=true EXPO_PUBLIC_POSTHOG_HOST=https://posthog-staging.neolexon.de/ APP_ENV=patient expo export -c -p web --output-dir ./dist/aphasia-patient-webapp --dump-sourcemap",
    "build-therapist-app-web-staging": "yarn gen-dependencies && EXPO_PUBLIC_API_URL=https://app-staging.neolexon.de EXPO_PUBLIC_ENVIRONMENT=staging EXPO_PUBLIC_POSTHOG_ENABLED=false EXPO_PUBLIC_POSTHOG_HOST=https://posthog-staging.neolexon.de/ APP_ENV=therapist expo export -c -p web --output-dir ./dist/aphasia-therapist-webapp --dump-sourcemap",
    "build-patient-app-web-bsi": "cp .env.bsi.example .env; APP_ENV=patient GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-patient-webapp",
    "build-therapist-app-web-bsi": "cp .env.bsi.example .env; APP_ENV=therapist GENERATE_SOURCEMAP=false expo export -c -p web --output-dir ./dist/aphasia-therapist-webapp",
    "######################": "",
    "cy:open": "cypress open",
    "cy:run": "cypress run",
    "dev": "start-test web 19006 cy:open",
    "dev:ci": "start-test web 19006 cy:run",
    "lint": "eslint ./ --fix",
    "prepare": "husky install",
    "postinstall": "husky install",
    "check-pre-commit": "npx eslint --quiet ./ && npx prettier --check -u ./",
    "audit-ci": "npx audit-ci@^7 --low --config ./audit-ci.jsonc"
  },
  "dependencies": {
    "@babel/plugin-proposal-export-default-from": "^7.25.9",
    "@babel/plugin-syntax-export-default-from": "^7.25.9",
    "@babel/plugin-transform-private-methods": "^7.25.9",
    "@babel/plugin-transform-private-property-in-object": "^7.25.9",
    "@babel/plugin-transform-runtime": "^7.26.9",
    "@bufgix/react-native-secure-window": "^0.1.1",
    "@expo/metro-runtime": "~5.0.4",
    "@expo/vector-icons": "^14.0.3",
    "@miblanchard/react-native-slider": "^2.3.1",
    "@react-native-async-storage/async-storage": "2.1.2",
    "@react-native-community/masked-view": "0.1.11",
    "@react-native-community/slider": "4.5.7",
    "@react-navigation/drawer": "^6.6.15",
    "@react-navigation/native": "^6.1.7",
    "@react-navigation/stack": "^6.3.17",
    "@sentry/react-native": "~7.0.0",
    "@types/node": "^22.8.2",
    "@types/react": "~19.0.10",
    "axios": "^1.5.0",
    "bcryptjs": "^2.4.3",
    "bowser": "^2.11.0",
    "chart.js": "^4.4.0",
    "cypress-iframe": "^1.0.1",
    "diff": "^8.0.3",
    "easy-peasy": "^6.0.2",
    "eslint-config-expo": "~9.2.0",
    "expo": "53",
    "expo-auth-session": "~6.2.1",
    "expo-av": "~15.1.7",
    "expo-blur": "~14.1.5",
    "expo-build-properties": "^1.0.10",
    "expo-clipboard": "~7.1.5",
    "expo-constants": "~17.1.7",
    "expo-crypto": "~14.1.5",
    "expo-dev-client": "~5.2.4",
    "expo-device": "~7.1.4",
    "expo-file-system": "~18.1.11",
    "expo-font": "~13.3.2",
    "expo-linking": "~7.1.7",
    "expo-navigation-bar": "~4.2.8",
    "expo-network": "~7.1.5",
    "expo-screen-capture": "~7.2.0",
    "expo-screen-orientation": "~8.1.7",
    "expo-secure-store": "~14.2.4",
    "expo-sharing": "~13.1.5",
    "expo-splash-screen": "~0.30.10",
    "expo-status-bar": "~2.2.3",
    "expo-video": "~2.2.2",
    "expo-web-browser": "~14.2.0",
    "highcharts": "^11.1.0",
    "highcharts-react-official": "^3.2.1",
    "html2canvas": "^1.4.1",
    "localforage": "^1.9.0",
    "lodash": "^4.17.21",
    "moment": "^2.29.1",
    "nativewind": "^2.0.11",
    "p-limit": "^4.0.0",
    "posthog-react-native": "^4.37.4",
    "prettier": "^3.5.3",
    "prop-types": "^15.7.2",
    "react": "19.0.0",
    "react-dom": "19.0.0",
    "react-error-boundary": "^4.0.13",
    "react-hook-form": "^7.46.1",
    "react-markdown": "^6.0.3",
    "react-native": "0.79.5",
    "react-native-aes-gcm-crypto": "^0.2.2",
    "react-native-animatable": "^1.3.3",
    "react-native-confetti-cannon": "^1.5.2",
    "react-native-default-preference": "^1.4.4",
    "react-native-device-info": "^14.0.2",
    "react-native-element-dropdown": "^2.12.4",
    "react-native-elements": "^3.4.1",
    "react-native-gesture-handler": "~2.24.0",
    "react-native-get-random-values": "~1.11.0",
    "react-native-keyboard-aware-scroll-view": "^0.9.4",
    "react-native-modal": "^13.0.1",
    "react-native-progress": "^5.0.0",
    "react-native-reanimated": "3.17.4",
    "react-native-render-html": "^6.3.4",
    "react-native-safe-area-context": "5.4.0",
    "react-native-screens": "~4.11.1",
    "react-native-slider": "^0.11.0",
    "react-native-slider-web": "^0.1.2",
    "react-native-ssl-public-key-pinning": "^1.2.5",
    "react-native-svg": "15.11.2",
    "react-native-toast-message": "2.2.0",
    "react-native-uuid": "^2.0.1",
    "react-native-vector-icons": "^10.1.0",
    "react-native-web": "^0.20.0",
    "react-native-webview": "13.13.5",
    "typescript": "~5.8.3"
  },
  "devDependencies": {
    "@babel/core": "^7.22.17",
    "@babel/eslint-parser": "^7.22.15",
    "@types/lodash": "^4.17.9",
    "babel-eslint": "^10.1.0",
    "babel-plugin-module-resolver": "^5.0.0",
    "cypress": "^15.15.0",
    "cypress-wait-until": "^2.0.1",
    "eslint": "^8.49.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-native": "^4.1.0",
    "husky": "^8.0.1",
    "mochawesome": "^7.1.3",
    "postcss": "^8.4.29",
    "tailwindcss": "3.3.2"
  },
  "husky": {
    "hooks": {
      "applypatch-msg": "echo \"[Husky] applypatch-msg\"",
      "pre-applypatch": "echo \"[Husky] pre-applypatch\"",
      "post-applypatch": "echo \"[Husky] post-applypatch\"",
      "pre-commit": "echo \"[Husky] pre-commit\""
    }
  },
  "expo": {
    "autolinking": {
      "android": {
        "exclude": [
          "@bufgix/react-native-secure-window"
        ]
      }
    }
  }
}
